export const welcomeFlowABTest = {
	event: "optimize.activate_newLoginab",
	loginType: "FirstLogin",
};
